import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { CardBaseProps } from "./CardBase.types";
import { StyledCardBase } from "./CardBase.styles";

/**
 * This is a 'base' component and should not be exported. Presently, for internal use only.
 */
const CardBase: FC<CardBaseProps> = ({
	className,
	borderRadius = "xl",
	padding = "xl",
	backgroundColor = "white",
	...props
}) => {
	const block = new BemIt("CardBase");

	return (
		<StyledCardBase
			className={addClass(className).after(block)}
			backgroundColor={backgroundColor}
			borderRadius={borderRadius}
			padding={padding}
			{...props}
		/>
	);
};

export default CardBase;
